module.exports = __webpack_public_path__ + "static/img/TFT Teamfight Tactics.5d8c158c.png";